import Vue from "vue"
import Vuex from "vuex"
import plugins from "@/store/plugins"
import state from "@/store/state"
import mutations from "@/store/mutations"
import actions from "@/store/actions"
import getters from "@/store/getters"
import modules from "@/store/modules"
import watchers from "./watchers"

Vue.use(Vuex)

const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    modules,
    plugins,
})

watchers.forEach(({ getter, cb, options }) => store.watch(getter, cb, options))

export default store
